var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',[_c('div',{staticClass:"modal--mask"},[_c('div',{staticClass:"modal--wrapper"},[_c('div',{staticClass:"loader"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }